import React, { useEffect } from "react";
import { BookingStep, TimeSlot, BookingLanguage } from "@/types/booking";
import type { SlotSelectionUpdateOptions } from "@/hooks/booking/useTimeSlots";
import MainStepContent from "./steps/MainStepContent";

// Define the component map type for consistency
type ComponentMap =
  | Record<string, string[]>
  | { internalUpdate: boolean }
  | { skipAddons: boolean };

interface BookingStepsProps {
  currentStep: BookingStep;
  handleProductSelect: (
    productIds: string[],
    componentMap?: ComponentMap,
  ) => void;
  handleClinicSelect: () => void;
  selectedProducts: string[];
  selectedClinic: string;
  handleClinicChange: (clinicId: string) => void;
  handleProductRemove: (productId: string) => void;
  handleBack: () => void;
  canGoBack: boolean;
  language: BookingLanguage;
  currentDate?: Date;
  handleDateSelect: (date: Date | undefined) => void;
  selectedTimeSlots: TimeSlot[];
  bookingType: "request";
  setBookingType: (type: "request") => void;
  handleTimeSelect: (
    times: string[],
    options?: SlotSelectionUpdateOptions,
  ) => void;
  handleDeleteTimeSlot: (slot: TimeSlot) => void;
  setCurrentStep: (step: BookingStep) => void;
  handleFormSubmit: (data: any) => void;
  formData: any;
  bookingId: string;
  setBookingId: (id: string) => void;
  selectedAddOns: string[];
  handleAddOnToggle: (productId: string) => void;
  viewMode: "packages" | "configure";
  setViewMode: (mode: "packages" | "configure") => void;
  selectedPackageType?: string;
}

const BookingSteps = ({
  currentStep,
  handleProductSelect,
  handleClinicSelect,
  selectedProducts,
  selectedClinic,
  handleClinicChange,
  handleProductRemove,
  handleBack,
  canGoBack,
  language,
  currentDate,
  handleDateSelect,
  selectedTimeSlots,
  bookingType,
  setBookingType,
  handleTimeSelect,
  handleDeleteTimeSlot,
  setCurrentStep,
  handleFormSubmit,
  formData,
  bookingId,
  setBookingId,
  selectedAddOns = [],
  handleAddOnToggle,
  viewMode,
  setViewMode,
  selectedPackageType,
}: BookingStepsProps) => {
  // Log selected clinic ID for debugging
  useEffect(() => {
    console.log("BookingSteps - Selected clinic ID:", selectedClinic);
  }, [selectedClinic]);

  return (
    <div className="w-full">
      <MainStepContent
        currentStep={currentStep}
        handleProductSelect={handleProductSelect}
        handleClinicSelect={handleClinicSelect}
        selectedProducts={selectedProducts}
        selectedClinic={selectedClinic}
        handleClinicChange={handleClinicChange}
        handleProductRemove={handleProductRemove}
        handleBack={handleBack}
        canGoBack={canGoBack}
        language={language}
        currentDate={currentDate}
        handleDateSelect={handleDateSelect}
        selectedTimeSlots={selectedTimeSlots}
        bookingType={bookingType}
        setBookingType={setBookingType}
        handleTimeSelect={handleTimeSelect}
        handleDeleteTimeSlot={handleDeleteTimeSlot}
        setCurrentStep={setCurrentStep}
        handleFormSubmit={handleFormSubmit}
        formData={formData}
        bookingId={bookingId}
        setBookingId={setBookingId}
        selectedAddOns={selectedAddOns}
        onAddOnToggle={handleAddOnToggle}
        viewMode={viewMode}
        setViewMode={setViewMode}
        selectedPackageType={selectedPackageType}
      />
    </div>
  );
};

export default BookingSteps;
